import { render, staticRenderFns } from "./widget-template-card.vue?vue&type=template&id=31207aef&scoped=true&"
import script from "./widget-template-card.vue?vue&type=script&lang=js&"
export * from "./widget-template-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31207aef",
  null
  
)

export default component.exports